import { CMSLink } from "../../CMSLink";
import { CarouselBlock } from "@onclicks/payload-types";

type LinksFromCarousel = NonNullable<CarouselBlock["links"]>[number];

export function CommentCall({ data }: { data: LinksFromCarousel[] }) {
  return data.map(({ link, id }) => (
    <CMSLink
      key={id}
      {...link}
      className="mx-auto mt-8 flex w-fit gap-x-2 rounded-md bg-[#009EE2] p-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#5CB5DB]"
    />
  ));
}
